
import _ from 'lodash'
import { notify } from '@/utils'

let stripePublicKey = null,
    stripeObj;

const stripeOptions = {
        locale: 'es'
    },
    style = {
        // base: {
            // color: '#00B04E',
            // backgroundColor: '#2d2d2d',
            // '::placeholder': {
                // color: '#aab7c4'
            // }
        // },
        // invalid: {
            // color: '#fa755a',
            // iconColor: '#fa755a'
        // }
    };

function initialize() {
    let Stripe = window.Stripe || null;
    try {
        if (!_.isObjectLike(Stripe))
            stripeObj = Stripe(stripePublicKey, stripeOptions);
        return stripeObj;
    } catch (e) {
        notify(e)
    }
}

function getStripePublicKey() {
    return stripePublicKey;
}

let setStripePublicKey = (publicKey) => {
    stripePublicKey = publicKey;
}

export default {
    getStripePublicKey,
    setStripePublicKey,
    stripeObj,
    initialize,
    style
}